import React from 'react';
import style from './App.module.scss'
import Header from './components/header/Header';
import { BrowserRouter } from "react-router-dom";
import Box from './components/box/Box';
import { useSelector } from 'react-redux';
import { selectHeader } from './redux/headerSlices/HeaderSelector'

function App() {

  const { topic } = useSelector(selectHeader)

  return (
    <div className={topic ? style.Body__white : style.Body}>
      <BrowserRouter>
        <Header />
        <Box />
      </BrowserRouter>
    </div>
  );
}

export default App;
